import React, { useEffect, useState } from "react";
import {
  FiUser,
  FiMail,
  FiPhone,
  FiHash,
  FiCalendar,
  FiLogOut,
  FiHome,
  FiShoppingBag,
  FiLock
} from "react-icons/fi";

import { useNavigate, useLocation } from "react-router-dom";
import "./Profile.css";
import BASE_URL from "../config";


function Profile(){

const navigate = useNavigate();
const location = useLocation();

const [user,setUser]=useState(null);


useEffect(()=>{

const token = localStorage.getItem("token");


if(!token){
navigate("/Userlogin");
return;
}


fetch(`${BASE_URL}/api/user/profile`,{

headers:{
Authorization:`Bearer ${token}`
}

})

.then(res=>res.json())

.then(data=>{

if(data.success){

setUser(data.user);

}else{

localStorage.clear();
navigate("/Userlogin");

}

});


},[navigate]);



const logout=()=>{

localStorage.clear();

navigate("/");

};



if(!user){

return(

<div className="profile-loader">
<div className="loader"></div>
</div>

)

}



return(

<div className="profile-dashboard">


{/* SIDEBAR */}

<div className="profile-sidebar">


<h2>
SAH <span>SCENTS</span>
</h2>


<ul>

<li className="active">
<FiUser/>
Profile
</li>


<li 
className={location.pathname === "/shop" ? "active" : ""}
onClick={()=>navigate("/shop")}
>
  <FiShoppingBag/>
  Shop
</li>

<li onClick={logout}>
<FiLogOut/>
Logout
</li>


</ul>


</div>




{/* CONTENT */}


<div className="profile-content">


<h1>Profile Page</h1>



<div className="profile-main-card">


<div className="profile-photo">

<div className="profile-avatar">

{user.name.charAt(0).toUpperCase()}

</div>


<h2>{user.name}</h2>

<p>Premium Member</p>


</div>




<div className="profile-fields">



<div className="field">

<label>
<FiUser/> Name
</label>

<input value={user.name} readOnly/>

</div>




<div className="field">

<label>
<FiMail/> Email
</label>

<input value={user.email} readOnly/>

</div>




<div className="field">

<label>
<FiPhone/> Phone
</label>

<input value={user.phone} readOnly/>

</div>




<div className="field">

<label>
<FiHash/> Customer ID
</label>

<input value={`SAH${user.id}`} readOnly/>

</div>




<div className="field">

<label>
<FiCalendar/> Member Since
</label>

<input 
value={new Date(user.created_at).toLocaleDateString()}
readOnly
/>

</div>



<button onClick={logout}>

<FiLogOut/>
Logout

</button>



</div>


</div>



</div>



</div>

)

}


export default Profile;